var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thankyou"},[_c('div',{staticClass:"container"},[_c('h6',[_vm._v(_vm._s(this.$t('Submission Confirmation Screen')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }